import React from "react";
import { connect } from "react-redux";
import { Switch, Route, Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import "./styles.scss";
import HvButton from "../../shared/HvButton";
import { ReactComponent as CopyLink } from "../../../../public/icons/UserProfile/copyLink.svg";
import { ReactComponent as Instagram } from "../../../../public/icons/UserProfile/socialMedia/instagram.svg";
import { ReactComponent as Facebook } from "../../../../public/icons/UserProfile/socialMedia/facebook.svg";
import { ReactComponent as Twitter } from "../../../../public/icons/UserProfile/socialMedia/twitter.svg";
import { ReactComponent as Youtube } from "../../../../public/icons/UserProfile/socialMedia/youtube.svg";
import { ReactComponent as Itunes } from "../../../../public/icons/UserProfile/socialMedia/itunes.svg";
import { ReactComponent as Website } from "../../../../public/icons/UserProfile/socialMedia/website.svg";
import { ReactComponent as Soundcloud } from "../../../../public/icons/UserProfile/socialMedia/soundcloud.svg";
import { ReactComponent as Spotify } from "../../../../public/icons/UserProfile/socialMedia/spotify.svg";
import { ReactComponent as Tiktok } from "../../../../public/icons/UserProfile/socialMedia/tiktok.svg";
import { ReactComponent as LocationIcon } from "../../../../public/shared/white-location-icon.svg";
import { ReactComponent as ShareIcon } from "../../../../public/post-icons/post-share-icon.svg";
import { ReactComponent as PlayButtonWhite } from "../../../shared/Svg/play-circle-icon-small.svg";
import defaultAlbumImg from "../../../../public/images/default-alblum-img.png";
import HeartOutline from "../../../shared/Svg/HeartOutline";
import HeartFilled from "../../../shared/Svg/HeartFilled";
import PlayButton from "../../../shared/Svg/PlayButton";
import Pause from "../../../shared/Svg/Pause";
import SharingModal from "../../../shared/SharingModal";
import { checkValidSocialMedia } from "../../../../helper/helper";
import { indexPosts } from "../../../../api/posts";
import { like, unlike } from "../../../../api/likes";
import { filterTimeStamp } from "../../../../api/helper";
import hv_player_api from "../../../../api/hv_player_api";
import Post from "../../PostsList/Post";
import MediaTag from "../../shared/MediaTag";
import PlaylistSquareTag from "../../shared/PlaylistSquareTag";
import Album from "../../shared/Album";
import { log_error } from "../../../../api";
import RollOver from "../../../RollOver";
import Linkify from "linkifyjs/react";
import { indexPlaylists } from "../../../../api/playlists";
import PostAttachments from "../../PostsList/Post/PostBody/PostAttachments";
import PostAttachmentsMobile from "../../PostsList/Post/PostBody/PostAttachmentsMobile";
// import { indexSingles } from "../../../../api/sound_tracks";
import { latestReleases } from "../../../../api/sound_tracks";
import FollowButton from "../../WhoToFollow/FollowButton";

const Attachment = ({ post, attachment }) => {
  switch (attachment.type) {
    case "SoundTrack":
      return <MediaTag className="my-2" showProgress source={post} medium={attachment} />;
    case "Image":
      return <MediaTag className="img-fluid" showFullScreenImag medium={attachment} />;
    case "Video":
      return <MediaTag medium={attachment} className="w-100" />;
    case "Post":
      return <Post post={attachment} className="mx-5" />;
    case "Playlist":
      return <PlaylistSquareTag playlist={attachment} className="mx-5" />;
    case "Album":
      return <Album album={attachment} />;
    case "Podcast":
      return <PlaylistSquareTag playlist={attachment} className="mx-5" />;
    default:
      return JSON.stringify(attachment);
  }
};

const copyToClipBoard = async (user) => {
  let copyMe = user.shareable_link;
  if (copyMe == null) copyMe = window.location.host + "/" + user.slug;
  try {
    await navigator.clipboard.writeText(copyMe);
  } catch (err) {
    console.log(err);
  }
};

class ProfileBodyMobile extends React.Component {
  state = {
    filter: {},
    pageSize: 3,
    pageNumber: 0,
    pageSizeVisuals: 3,
    pageNumberVisuals: 0,
    pageSizeTracks: 3,
    pageNumberTracks: 0,
    posts: null,
    visuals: null,
    tracks: null,
    loadingMore: false,
    canLoadMore: true,
    playlists: null,
    singles: null,
    soundtracks: null,
  };

  actions = {
    onLikePost: (post) => {
      this.setState({
        posts: this.state.posts.map((p) => (p.id === post.id ? { ...p, is_liked: true, likes_count: p.likes_count + 1 } : p)),
      });
    },
    onUnlikePost: (post) => {
      this.setState({
        posts: this.state.posts.map((p) => (p.id === post.id ? { ...p, is_liked: false, likes_count: p.likes_count - 1 } : p)),
      });
    },
  };

  handleHeart = async (post) => {
    try {
      if (post.is_liked) {
        await unlike(post.type, post.id);
        this.actions.onUnlikePost(post);
      } else {
        await like(post.type, post.id);
        this.actions.onLikePost(post);
      }
    } catch (error) {
      log_error(error);
    }
  };

  componentDidMount() {
    this.fetchVisuals();
    this.fetchTracks();
    this.fetchPosts();
    this.fetchSinglesTracks();
    this.indexPlaylists();
  }

  indexPlaylists = async () => {
    this.setState({ playlists: null });
    let {
      data: { playlists, meta },
    } = await indexPlaylists({
      page_number: this.state.page_number,
      page_size: this.state.page_size,
      filter: { user_id: this.props.user.id, is_rss: true },
    });
    this.setState({ playlists, meta });
  };

  playlistSetter = (newPlaylist) =>
    this.setState({
      playlists: this.state.playlists.map((playlist) => (playlist.id === newPlaylist.id ? newPlaylist : playlist)),
    });

  renderSocialMedia = () => {
    if (this.props.user && this.props.user.social_media_links) {
      const component = {
        instagram: Instagram,
        facebook: Facebook,
        twitter: Twitter,
        youtube: Youtube,
        itunes: Itunes,
        website: Website,
        soundcloud: Soundcloud,
        spotify: Spotify,
        tiktok: Tiktok,
      };
      return Object.keys(this.props.user.social_media_links)
        .filter((a) => component[a])
        .map((social) => {
          const SocialIcon = component[social];
          let url = this.props.user.social_media_links[social];
          const isValidSocialMedia = checkValidSocialMedia(social);
          if (url && !isValidSocialMedia && !url.startsWith("http://") && !url.startsWith("https://")) url = `https://${url}`;
          if (url && isValidSocialMedia) {
            url = url?.includes(`${social}.com`) ? url : `https://${social}.com/${url}`;
          }
          return url ? (
            <a href={url} target="blank">
              <SocialIcon className="mr-2" />
            </a>
          ) : null;
        });
    }
    return null;
  };

  fetchPosts = async () => {
    try {
      this.setState({ loadingMore: true });
      let {
        data: { posts },
      } = await indexPosts({
        filter: { author_id: this.props.user.id },
        page_number: this.state.pageNumber,
        page_size: this.state.pageSize,
      });
      this.setState({
        posts: this.state.posts ? [...this.state.posts, ...posts] : posts,
        pageNumber: this.state.pageNumber + 1,
        canLoadMore: posts.length === this.state.pageSize,
      });
    } catch (error) {
      console.log(error);
      this.setState({ posts: [] });
    } finally {
      this.setState({ loadingMore: false });
    }
  };

  fetchVisuals = async () => {
    try {
      this.setState({ loadingMore: true });
      let {
        data: { posts },
      } = await indexPosts({
        filter: { author_id: this.props.user.id, attachment_type: "Video" },
        page_number: this.state.pageNumberVisuals,
        page_size: this.state.pageSizeVisuals,
      });
      this.setState({
        visuals: this.state.visuals ? [...this.state.visuals, ...posts] : posts,
        pageNumberVisuals: this.state.pageNumberVisuals + 1,
        canLoadMore: posts.length === this.state.pageSizeVisuals,
      });
    } catch (error) {
      console.log(error);
      this.setState({ visuals: [] });
    } finally {
      this.setState({ loadingMore: false });
    }
  };

  fetchTracks = async () => {
    try {
      this.setState({ loadingMore: true });
      let {
        data: { posts },
      } = await indexPosts({
        filter: { author_id: this.props.user.id, attachment_type: "SoundTrack" },
        page_number: this.state.pageNumberTracks,
        page_size: this.state.pageSizeTracks,
      });
      this.setState({
        tracks: this.state.tracks ? [...this.state.tracks, ...posts] : posts,
        pageNumberTracks: this.state.pageNumberTracks + 1,
        canLoadMore: posts.length === this.state.pageSizeTracks,
      });
    } catch (error) {
      console.log(error);
      this.setState({ tracks: [] });
    } finally {
      this.setState({ loadingMore: false });
    }
  };

  fetchSinglesTracks = async () => {
    try {
      this.setState({ loadingMore: true });
      let {
        data: { soundtracks },
      } = await latestReleases({
        filter: { user_id: this.props.user.id },
        page_number: this.state.pageNumberTracks,
        page_size: this.state.pageSizeTracks,
      });
      this.setState({
        singles: this.state.singles ? [...this.state.singles, ...soundtracks] : soundtracks,
        pageNumberTracks: this.state.pageNumberTracks + 1,
        canLoadMore: soundtracks.length === this.state.pageSizeTracks,
      });
    } catch (error) {
      console.log(error);
      this.setState({ singles: [] });
    } finally {
      this.setState({ loadingMore: false });
    }
  };

  original_object = (post) =>
    post.type === "Post" && post.attachments.some((a) => a.type === "Post")
      ? this.original_object(post.attachments.find((a) => a.type === "Post"))
      : post;
  render() {
    let backgroundStyle = {};
    if (this.props.user.cover_image && this.props.user.cover_image.type === "Image")
      backgroundStyle.backgroundImage = `url(${this.props.user.cover_image && this.props.user.cover_image.url})`;
    backgroundStyle.backgroundRepeat = "no-repeat";
    backgroundStyle.backgroundPosition = "center";
    return (
      <div className="theme-dark-bg">
        <section className="video-banner-1" style={{ ...backgroundStyle, position: "relative" }}>
          {this.props.user.cover_image && (this.props.user.cover_image.type === "Video" || this.props.user.cover_image.type === "DefaultCover") ? (
            <video ref="vidRef" playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop" className="inlineCoverVideo">
              <source src={this.props.user.cover_image.url} type="video/mp4" />
            </video>
          ) : null}
          <div className="box-container">
            <div className="transprent-overlay"></div>
            <div className="video-banner-content">
              <h4 className="video-title-1">
                <span>{this.props.user.username}</span>
              </h4>
              <div className="video-stats">
                <span>{this.props.user.user_type}</span>
                <LocationIcon className="mx-1" />
                <span>
                  {this.props.user.address && this.props.user.address.city ? this.props.user.address.city + ", " : ""}
                  {this.props.user.address && this.props.user.address.state ? this.props.user.address.state + ", " : ""}
                  {this.props.user.address && this.props.user.address.country === "United States of America"
                    ? "USA"
                    : this.props.user.address.country}
                </span>
              </div>
              {this.props.user && !Object.values(this.props.user.social_media_links).every((element) => element === null || element === "") && (
                <>
                  <hr />
                  <ul className="banner-icons">{this.renderSocialMedia()}</ul>
                </>
              )}
              <hr />
              <div className="video-btn-group">
                {this.props.user.artist_profile && this.props.user.is_subscribed_to_tipjar && this.props.user.artist_profile.paypal_me_tag && (
                  <Link to={`/${this.props.user.slug}/tip-jar`}>
                    <button className="btn btn-border-plain">Tip</button>
                  </Link>
                )}
                <RollOver text="Copied" className="tooltip-for-profile-clipboard-modal">
                  <button className="btn btn-border-plain" onClick={() => copyToClipBoard(this.props.user)}>
                    <CopyLink className="mr-1" />
                    Copy profile Link
                  </button>
                </RollOver>
              </div>
            </div>
          </div>
          {this.props.current_user && (
            <div style={{ position: "absolute", top: 20, left: 20 }}>
              <FollowButton className="text-white" varient="border-plain" user={this.props.user} />
            </div>
          )}
        </section>
        {this.state.visuals && this.state.visuals.length > 0 && (
          <section>
            <div className="box-container">
              <h4 className="theme-title">Newest Visuals</h4>
              <div className="box-row newest-video-list">
                {this.state.visuals &&
                  this.state.visuals.map((visual) => (
                    <div className="box-col-3">
                      <div className="video-box">
                        {visual.attachments.map((attachment) => (
                          <>{attachment.type === "Video" ? <Attachment post={visual} attachment={attachment} key={attachment.id} /> : null}</>
                        ))}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </section>
        )}

        {this.state.tracks && this.state.tracks.length > 0 && this.state.singles && this.state.singles.length == 0 && (
          <section>
            <div className="box-container">
              <h4 className="theme-title">Latest Favorites</h4>
              <div className="box-row video-tracks-list">
                {this.state.tracks &&
                  this.state.tracks.map((track) => (
                    <div className="box-col-3">
                      <div className="track-box">
                        {track.attachments.map((attachment) => (
                          <>
                            <img
                              src={attachment.preview_image ? attachment.preview_image.url : defaultAlbumImg}
                              alt="ALBUM-THUMBNAIL"
                              className="track-img-small"
                            />
                            <h5 className="track-title-1">{attachment.title ? attachment.title : "No Title"}</h5>
                            {this.props.currently_playing.id == attachment.id ? (
                              this.props.currently_playing.status === "ready" ? (
                                this.props.playing ? (
                                  <Pause className="play-icon" onClick={hv_player_api.pause} />
                                ) : (
                                  <PlayButtonWhite className="play-icon" onClick={() => hv_player_api.playMediaWithoutSource(attachment)} />
                                )
                              ) : (
                                <Spinner animation="border" variant="white" size="lg" role="status" style={{ width: "1.5rem", height: "1.5rem" }} />
                              )
                            ) : (
                              <PlayButtonWhite className="play-icon" onClick={() => hv_player_api.playMediaWithoutSource(attachment)} />
                            )}
                          </>
                        ))}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </section>
        )}

        {this.state.singles && this.state.singles.length > 0 && (
          <section>
            <div className="box-container">
              <h4 className="theme-title">Latest Releases</h4>
              <div className="box-row video-tracks-list">
                {this.state.singles &&
                  this.state.singles.map((attachment) => (
                    <div className="box-col-3">
                      <div className="track-box">
                        <>
                          <img
                            src={attachment.preview_image ? attachment.preview_image.url : defaultAlbumImg}
                            alt="ALBUM-THUMBNAIL"
                            className="track-img-small"
                          />
                          <h5 className="track-title-1">{attachment.title ? attachment.title : "No Title"}</h5>
                          {this.props.currently_playing.id == attachment.id ? (
                            this.props.currently_playing.status === "ready" ? (
                              this.props.playing ? (
                                <Pause className="play-icon" onClick={hv_player_api.pause} />
                              ) : (
                                <PlayButtonWhite className="play-icon" onClick={() => hv_player_api.playMediaWithoutSource(attachment)} />
                              )
                            ) : (
                              <Spinner animation="border" variant="white" size="lg" role="status" style={{ width: "1.5rem", height: "1.5rem" }} />
                            )
                          ) : (
                            <PlayButtonWhite className="play-icon" onClick={() => hv_player_api.playMediaWithoutSource(attachment)} />
                          )}
                        </>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </section>
        )}

        {this.props.user.user_type == "podcaster" && this.state.playlists && this.state.playlists.length > 0 && (
          <section className="podcaster-common-padding">
            <div className="box-container">
              <h4 className="theme-title">Latest Podcasts</h4>
              <div className="podcasts-box-list">
                <div className="profile-grid-view">
                  {this.state.playlists.map((playlist) => (
                    <PlaylistSquareTag key={playlist.id} playlist={playlist} playlistSetter={this.playlistSetter} />
                  ))}
                </div>
              </div>
            </div>
          </section>
        )}

        {this.state.posts && this.state.posts.length > 0 && (
          <section>
            <div className="box-container">
              <h4 className="theme-title">Latest Posts</h4>
              <div className="posts-box-list">
                {this.state.posts &&
                  this.state.posts.map((post) => (
                    <div className="post-single-card">
                      <h4 className="post-card-title">
                        <span className="username">{this.props.user.username}</span>
                        <span className="date-light">{filterTimeStamp(post.created_at)}</span>
                      </h4>
                      <div className="post-content-box">
                        <h4 className="post-sub-title">{<Linkify tagName="pre">{post.text}</Linkify>}</h4>
                        {post.attachments.map((attachment) =>
                          attachment.type === "Post" ? (
                            <div className="post-attachment-box">
                              <PostAttachmentsMobile post={post} attachments={post.attachments} />
                            </div>
                          ) : attachment.type === "SoundTrack" ? (
                            <div className="track-box">
                              <img
                                src={attachment.preview_image ? attachment.preview_image.url : defaultAlbumImg}
                                alt="ALBUM-THUMBNAIL"
                                className="track-img-small"
                              />
                              <h5 className="track-title-1">{attachment.title ? attachment.title : "No Title"}</h5>
                              {this.props.currently_playing.id == attachment.id ? (
                                this.props.currently_playing.status === "ready" ? (
                                  this.props.playing ? (
                                    <Pause className="play-icon" onClick={hv_player_api.pause} />
                                  ) : (
                                    <PlayButtonWhite className="play-icon" onClick={() => hv_player_api.playMediaWithoutSource(attachment)} />
                                  )
                                ) : (
                                  <Spinner animation="border" variant="white" size="lg" role="status" style={{ width: "1.5rem", height: "1.5rem" }} />
                                )
                              ) : (
                                <PlayButtonWhite className="play-icon" onClick={() => hv_player_api.playMediaWithoutSource(attachment)} />
                              )}
                            </div>
                          ) : (
                            <Attachment post={post} attachment={attachment} key={attachment.id} />
                          )
                        )}
                      </div>
                      <div className="post-actions">
                        <div className={`heart mr-1 action ${post.is_liked && "active"}`} onClick={() => this.handleHeart(post)}>
                          {post.is_liked ? <HeartFilled color="#f0047f" /> : <HeartOutline color="#fff" />}

                          <small className="text-default ml-1">{post.likes_count}</small>
                        </div>
                        <SharingModal onSubmit={post.refresh} attachments={[this.original_object(post)]}>
                          <div className="share mr-1 action">
                            <ShareIcon />
                          </div>
                        </SharingModal>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </section>
        )}

        {this.props.user.artist_profile && this.props.user.artist_profile.bio && this.props.user.artist_profile.bio.length && (
          <section>
            <div className="box-container">
              <h4 className="theme-title post-single-card">
                About <span className="username">{this.props.user.username}</span>
              </h4>
              <div className="posts-box-list">
                <div className="post-about-card">
                  <div className="post-content-box">
                    <h4 className="post-sub-title">{<Linkify tagName="pre">{this.props.user.artist_profile.bio}</Linkify>}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="img-container">
              {this.props.user.artist_profile.images.map((image) => (
                <img src={image.url} alt="bio"></img>
              ))}
            </div>
          </section>
        )}

        {this.props.user.user_type == "podcaster" && this.props.user.bio && this.props.user.bio.length && (
          <section>
            <div className="box-container">
              <h4 className="theme-title post-single-card">
                About <span className="username">{this.props.user.username}</span>
              </h4>
              <div className="posts-box-list">
                <div className="post-about-card">
                  <div className="post-content-box">
                    <h4 className="post-sub-title">{<Linkify tagName="pre">{this.props.user.bio}</Linkify>}</h4>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    );
  }
}

export default connect((state) => state)(ProfileBodyMobile);
